import styled from 'styled-components';

export const Table = styled.table`
  width: 100%;
  margin: ${props => props.theme.spacing.margin}px 0;
  border-spacing: ${props => props.theme.spacing.margin / 2}px;
`;